export const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (element) {
    // Remove any existing highlights
    document.querySelectorAll(".highlight-target").forEach((el) => {
      el.classList.remove("highlight-target");
      el.classList.remove("highlight-pulse");
      el.classList.remove("highlight-fade");
    });

    const navbarHeight = 70;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + window.pageYOffset - navbarHeight - 20;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });

    // Add highlight classes
    element.classList.add("highlight-target");
    element.classList.add("highlight-pulse");

    // After initial pulse animation
    setTimeout(() => {
      element.classList.remove("highlight-pulse");

      // Keep border glow for a while
      setTimeout(() => {
        element.classList.add("highlight-fade");
        // Finally remove all highlights
        setTimeout(() => {
          element.classList.remove("highlight-target");
          element.classList.remove("highlight-fade");
        }, 500);
      }, 3000);
    }, 1000);
  }
};
